"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _styledComponents = require("styled-components");
// класс который должен добавляться к body, когда необходимо убрать скол заднего фона у модалки
var freezeBody = (0, _styledComponents.css)(["body.modal-open{overflow:hidden;}"]);
var _default = exports["default"] = (0, _styledComponents.createGlobalStyle)(["", ";"], freezeBody);